// src/data/planning/planningConfig.js

import {
  OFFICIAL_ACTIVITY_CATALOG_VERSION
} from "./officialActivityCatalog";

import {
  TARGET_CATALOG_VERSION
} from "./targetCatalog";

import {
  TARGET_ACTIVITY_CATALOG_VERSION
} from "./targetActivityCatalog";

import {
  PLANNING_RULES_VERSION
} from "./planningRules";

import {
  CORE_PLAN_VERSION
} from "./corePlanTemplate";

import {
  TBM_PROGRAM_VERSION
} from "./tbmProgram";


/**
 * REHBER360 - PLANLAMA YILI KONFİGÜRASYONU
 *
 * Bu dosya eğitim öğretim yılına ait planlama
 * sisteminin merkezi ayar noktasıdır.
 *
 * Burada:
 * - Genel hedef
 * - Kullanılacak katalog sürümleri
 * - Plan motorunun aktiflik durumu
 * tutulur.
 *
 * Yerel hedef burada tutulmaz.
 * Yerel hedef kullanıcı tarafından seçilir.
 */


export const PLANNING_CONFIGS = {

  // =========================================================
  // 2026-2027
  // =========================================================

  "2026-2027": {

    academicYear: "2026-2027",

    status: "active",

    /**
     * GENEL HEDEF
     *
     * Bakanlık tarafından ülke genelinde belirlenir.
     * Kullanıcı değiştiremez.
     */
    generalTarget: {

      id: "selamlasma",

      label: "Selamlaşma",

      selectedBy: "system",

      locked: true
    },


    /**
     * HEDEF YAPISI
     *
     * Normal okul profilinde:
     * 1 Genel + 1 Yerel + 2 Özel hedef
     *
     * Nihai hedef sayısı planningRules.js
     * üzerinden belirlenir.
     */
    targetSelection: {

      localTarget: {
        selectedBy: "user",
        required: true
      },

      specialTargets: {
        selectedBy: "user",
        required: true
      }
    },


    /**
     * KULLANILAN VERİ SÜRÜMLERİ
     *
     * Plan oluşturulduğunda bu bilgiler
     * snapshot olarak plan kaydına alınacak.
     */
   versions: {

  officialActivityCatalog:
    OFFICIAL_ACTIVITY_CATALOG_VERSION,

  targetCatalog:
    TARGET_CATALOG_VERSION,

  targetActivityCatalog:
    TARGET_ACTIVITY_CATALOG_VERSION,

  planningRules:
    PLANNING_RULES_VERSION,

  corePlan:
    CORE_PLAN_VERSION,

  tbmProgram:
    TBM_PROGRAM_VERSION
},


    /**
     * TBM
     *
     * 2026-2027 resmi uygulama dağılımı
     * doğrulanmadığı için otomatik planlamada
     * şimdilik kullanılmayacak.
     */
    tbm: {

      automaticGenerationEnabled: false,

      status:
        "awaiting_official_schedule"
    },


    /**
     * TAKVİM
     *
     * Eğitim yılı takvim motorunu ayrı
     * oluşturacağız.
     */
    calendar: {

  version: "MEB-2026-2027-V1",

  status: "active"
}
  }

};


// =========================================================
// YARDIMCI FONKSİYONLAR
// =========================================================

export const getPlanningConfig = (
  academicYear
) => {

  return (
    PLANNING_CONFIGS[academicYear] ||
    null
  );
};


export const getActivePlanningConfig = (
  academicYear
) => {

  const config =
    getPlanningConfig(academicYear);

  if (
    !config ||
    config.status !== "active"
  ) {
    return null;
  }

  return config;
};


export const getGeneralTargetForYear = (
  academicYear
) => {

  const config =
    getActivePlanningConfig(
      academicYear
    );

  return (
    config?.generalTarget ||
    null
  );
};


export const getPlanningVersions = (
  academicYear
) => {

  const config =
    getActivePlanningConfig(
      academicYear
    );

  return (
    config?.versions ||
    null
  );
};